import React, { useEffect } from 'react'
import axios from 'axios'
import { Stack } from '@mui/material'

const PowerBiReport = () => {
  const [isLoading, setIsLoading] = React.useState(false)
  const [powerBiLink, setPowerBiLink] = React.useState(null)

  useEffect(() => {
    const fetchPowerBiLink = async () => {
      try {
        setIsLoading(true)
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_DATA_LOGGER_BASE_URL}/v1/power-bi-report/link`
          )
          console.log('response.data', response.data)
          setPowerBiLink(response.data.url)
        } catch (err) {
          console.log(err)
          return err.response
        }
      } finally {
        setIsLoading(false)
      }
    }
    fetchPowerBiLink()
  }, [])

  if (isLoading || !powerBiLink) {
    return <div>Loading...</div>
  }

  return (
    <Stack sx={{width:'100%', height:'100%'}}>
      <iframe
        src={powerBiLink}
        width="100%"
        height="600"
        title="Loaded Iframe"
        style={{ border: 'none' }}
      />
    </Stack>
  )
}

export default PowerBiReport
